import React, { useEffect } from "react"
import { createRoot } from "react-dom/client"

import appTheme from "appTheme"
import componentThemeExtension from "utils/componentThemeExtension"

import { Container, Heading, TableWrapper, TableText, CheckmarkYes, CheckmarkNo } from "./styles"

const Table = ({
  className,
  dataId,
  elRef,
  heading,
  subheading,
  tableData,
  displayTrueFalseAsCheckmarks,
  dataHasHeaderRow,
  headerRowColor,
  evenRowColor,
  oddRowColor,
  headerAlign,
  cellAlign,
  firstColumnAlign,
  lastColumnAlign,
  fullWidth,
  lockFirstColumnOnMobile,
  navigationAnchor,
  button,
  hideOnPageLoad,
}) => {
  const rowThemes = {
    header: componentThemeExtension(headerRowColor)(appTheme),
    even: componentThemeExtension(evenRowColor)(appTheme),
    odd: componentThemeExtension(oddRowColor)(appTheme),
  }

  const rowColors = {
    header: {
      text: rowThemes.header ? rowThemes.header.component.text : "inherit",
      background: rowThemes.header ? rowThemes.header.component.background : "inherit",
    },
    even: {
      text: rowThemes.even ? rowThemes.even.component.text : "inherit",
      background: rowThemes.even ? rowThemes.even.component.background : "inherit",
      highlight: rowThemes.even ? rowThemes.even.component.highlight : "inherit",
    },
    odd: {
      text: rowThemes.odd ? rowThemes.odd.component.text : "inherit",
      background: rowThemes.odd ? rowThemes.odd.component.background : "inherit",
      highlight: rowThemes.odd ? rowThemes.odd.component.highlight : "inherit",
    },
  }

  const align = {
    header: headerAlign,
    cell: cellAlign,
    firstColumn: firstColumnAlign,
    lastColumn: lastColumnAlign,
  }

  useEffect(() => {
    const renderCheckmark = (parent, component) => {
      parent.innerHTML = ""
      const container = document.createElement("div")
      parent.appendChild(container)
      const root = createRoot(container)
      root.render(component)
    }

    if (displayTrueFalseAsCheckmarks) {
      const elements = elRef.current.querySelectorAll("td")
      elements.forEach((element) => {
        if (element.innerHTML.match(/^[tT][rR][uU][eE]|[yY][eE][sS]$/g)) {
          renderCheckmark(element, <CheckmarkYes />)
        } else if (element.innerHTML.match(/^[fF][aA][lL][sS][eE]|[nN][oO]$/g)) {
          renderCheckmark(element, <CheckmarkNo />)
        }
      })
    }
  }, [displayTrueFalseAsCheckmarks, elRef])

  return (
    <Container className={className} ref={elRef} hideOnPageLoad={hideOnPageLoad}>
      <Heading title={heading} subtitle={subheading} />
      <TableWrapper>
        <TableText
          dataId={dataId}
          id={navigationAnchor}
          elRef={elRef}
          text={tableData}
          buttonElement={button}
          dataHasHeaderRow={dataHasHeaderRow}
          rowColors={rowColors}
          align={align}
          fullWidth={fullWidth}
          lockFirstColumnOnMobile={lockFirstColumnOnMobile}
        />
      </TableWrapper>
    </Container>
  )
}

export default Table
